import { createStore } from "vuex";
import Rawdata from "./store/rawdata";
import Media from "./store/dropdown/media";
import Sector from "./store/dropdown/sector";
import Audience from "./store/dropdown/audience";
import mics from "./store/mics";
// import Myexcel from "./store/excel";
import Myexcel from "./store/myexcel";
export default createStore({
  modules: {
    Rawdata,
    Media,
    Sector,
    Audience,
    mics,
    Myexcel,
  },
});
